import { render, staticRenderFns } from "./info_h5.vue?vue&type=template&id=0c25d4a6&scoped=true&"
import script from "./info_h5.vue?vue&type=script&lang=js&"
export * from "./info_h5.vue?vue&type=script&lang=js&"
import style0 from "./info_h5.vue?vue&type=style&index=0&id=0c25d4a6&lang=less&scoped=true&"
import style1 from "./info_h5.vue?vue&type=style&index=1&id=0c25d4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25d4a6",
  null
  
)

export default component.exports